import * as React from "react";
import { Card, CardMedia, Box } from '@mui/material';
import Image from 'components/Image';
import playButton from 'images/play-button.svg';
import pauseButton from 'images/pause-button.svg';

const MediaCard = ({ position, video, buttonPosition = "" }) => {
	const videoRef = React.useRef(null);
	const [isPlaying, setIsPlaying] = React.useState(false);

	const togglePlay = () => {
		if (videoRef.current) {
			if (isPlaying) {
				videoRef.current.pause();
			} else {
				videoRef.current.play();
			}
			setIsPlaying(!isPlaying);
		}
	};

	return (
		<Card raised={true} variant='video' position={position} onClick={togglePlay}>
			<CardMedia
				component="video"
				alt="Embedded Video"
				src="video"
				image={`${process.env.CDN_DOMAIN||''}${video}`}
				controls
				ref={videoRef}
				type="video/mp4"
			/>
			<Box className={buttonPosition}>
				{(isPlaying) ? (<Image width={"56"} height={"56"} src={pauseButton} />) : (<Image width={"56"} height={"56"} src={playButton} />)}
			</Box>
		</Card>
	);
};

export default MediaCard;